import { useLayoutEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useListContext } from 'react-admin';
import isEqual from 'lodash/isEqual';

/**
 * Keeps react-hook-form in sync with ListContext.filterValues (e.g. filters set via URL or table links).
 * Required after React 19 upgrade: ReferenceArrayInput reads form state, not filterValues directly.
 */
export const useSyncFilterFormValue = source => {
    const { filterValues } = useListContext();
    const { setValue, getValues } = useFormContext();
    const listValue = filterValues?.[source];

    useLayoutEffect(() => {
        if (listValue === undefined) {
            return;
        }

        const formValue = getValues(source);
        if (!isEqual(formValue, listValue)) {
            setValue(source, listValue, { shouldDirty: false, shouldTouch: false, shouldValidate: false });
        }
    }, [listValue, source, setValue, getValues]);
};
